const phonenumber = {
	name: 'Phone Number | Phone Numbers',
	icon: 'fa-solid fa-phone',
	fields: {
		number: 'Number',
		communication_type: 'Communication type',
		description: 'Description',
		notice: 'Notice',
		typeNotFound: 'Type not found',
	},
}

export default phonenumber
